const IMAGE_ROUTE = '/kb-articles/images/'

/**
 * The API path for a KB image link, or null when the link isn't one. Article Markdown is
 * free text, so an absolute link must point at our API: the path goes through the authed
 * client, and a look-alike on another origin would otherwise receive the reader's token.
 */
export function kbImageApiPath(src: string | undefined, apiBase: string = import.meta.env.VITE_API_URL ?? ''): string | null {
  if (!src) return null
  if (src.startsWith(IMAGE_ROUTE)) return src
  let url: URL
  let base: URL
  try {
    url = new URL(src)
    base = new URL(apiBase)
  } catch {
    return null
  }
  const basePath = base.pathname.replace(/\/$/, '')
  if (url.origin !== base.origin || !url.pathname.startsWith(`${basePath}${IMAGE_ROUTE}`)) return null
  return url.pathname.slice(basePath.length)
}
